export default __webpack_public_path__ + "static/logo-c27d0f1d89929935f0cc6dc0b3694235.png";